// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { inspect } from "node:util";

export const custom = inspect.custom;
